
import { VAvatar } from "vuetify/lib";

export default VAvatar.extend({});
